import { SidePanelProvider } from "components/SidePanel/SidePanelContext";
import SidePanelRoot from "components/SidePanel/SidePanelRoot";
import SidebarNavigation from "components/SidebarNavigation/SidebarNavigation";
import { loadTheme } from "components/theme/theme";
import TopBar from "components/TopNavigation/TopBar";
import TopNavigation from "components/TopNavigation/TopNavigation";
import moment from "moment";
import { signalRStart } from "notifications/signalrmiddleware";
import React, { useMemo } from "react";
import { getNewButton, renderBreadcrumbsIfDefined } from "./bootstrapNavigation";
import DefaultProviders from "./DefaultProviders";
import { Outlet } from "react-router";
import TopBarAnonymous from "components/TopNavigation/TopBarAnonymous";
import { PlanningProvider } from "PlanningContext/PlanningContext";
import { RightClickMenuContextProvider } from "components/RightClickMenu/RightClickMenuContext";
import { ToastRoot } from "components/Toast/ToastRoot";
import { NewFeatureAdModal } from "components/Ad/NewFeatureAdModal";

export const init = () => {
  loadTheme();

  moment.locale(serverReference.culture.uiLocale);

  if (site.currentUser) {
    signalRStart();
  }
}

const SystemOneApp = (props: React.PropsWithChildren<any>) => {
  useMemo(() => {
    init();
  }, []);

  if (site.currentEnvironment === null) {
    return <DefaultProviders>
      <div id="pagecontainer">
        <div className="flex">
          <div style={{
            width: "100%",
            overflowX: "hidden",
          }}>
            <TopBarAnonymous />
            <div id="contentholder">
              <Outlet />
              {props.children}
            </div>
          </div>
          <SidePanelRoot />
          <ToastRoot />
        </div>
      </div>
    </DefaultProviders>;
  }

  return <DefaultProviders>
    <SidePanelProvider>
      <RightClickMenuContextProvider>
        <PlanningProvider>
          <div id="pagecontainer">
            <SidebarNavigation
              navigation={desktopNavigation}
              currentPage={desktopNavigation.currentPage}
            />
            <div className="flex">
              <div style={{
                width: "100%",
                overflowX: "hidden",
              }}>
                <TopBar
                  notificationCount={site.unseenNotificationCount}
                  onMenuOpen={() => { window.onSideNavOpen(); }}
                />
                {renderBreadcrumbsIfDefined()}
                <TopNavigation
                  currentPage={desktopNavigation.currentPage}
                  navigation={desktopNavigation}
                  newButton={getNewButton()}
                />
                <NewFeatureAdModal
                  visibleFrom={moment.utc("2026-08-31T00:00:00Z")}
                  visibleUntil={moment.utc("2026-09-11T00:00:00Z")}
                  imageUrl="https://cdn.systemonesoftware.com/images/announce-2-v1.png"
                  learnMoreUrl="https://www.systemonesoftware.com/changelog/introducing-the-new-systemone-mobile-app"
                  title="New mobile app"
                  id="announce-2"
                />
                <div id="contentholder">
                  <Outlet />
                  {props.children}
                </div>
              </div>
              <SidePanelRoot />
              <ToastRoot />
            </div>
          </div>
        </PlanningProvider>
      </RightClickMenuContextProvider>
    </SidePanelProvider>
  </DefaultProviders>;
};

export default SystemOneApp;